import { Application } from '@platform/client';
import { ProfessionalApplicationParameters, UploadResponse } from '@platform/client/schemas';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import { ProfilePictureUploadButton } from '../../components/ProfilePictureUploadButton';
import { ProfilePictureShowcase } from './ProfilePictureShowcase';

type FormValues = {
  profilePicture: string | null;
};

export const ProfilePictureUpload = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress, isEditProfile, onSaveExit, dataKey } = { ...props };
  const [file, setFile] = useState<File>();
  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<ProfessionalApplicationParameters>(dataKey);

  const uploadPicture = Application.useUploadProfilePicture();

  const existingPicture = getApplicationDataByKey('profilePicture');

  const { handleSubmit } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      profilePicture: existingPicture || '',
    },
  });

  const submit = () => {
    if (file) {
      uploadPicture.mutate(
        {
          data: {
            file,
          },
        },
        {
          onSuccess: (response) => {
            updateApplicationData({ profilePicture: (response as UploadResponse).url || null });
            onContinue();
          },
        },
      );
    } else {
      updateApplicationData({ profilePicture: null });
      onContinue();
    }
  };

  return (
    <ApplicationBackground
      progress={progress}
      onBack={onBack}
      onSubmit={handleSubmit(submit)}
      isEditProfile={isEditProfile}
      onSaveAndExit={onSaveExit}
      customLeftPanelContent={<ProfilePictureShowcase />}
    >
      <ApplicationPageContent
        title='Make your profile stand out'
        description="It's not required, but a picture increases engagement with your profile."
      >
        <ProfilePictureUploadButton
          file={file}
          setFile={setFile}
          existingPicture={existingPicture}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
